import { UNIT } from '../../constants/configuration';

const styles = {
  receiptProductItemTitleStyle: { fontSize: UNIT * 1.5, fontWeight: '500' },
  receiptProductItemTitleDefaultStyle: { marginBottom: '3px', fontWeight: '500' }
};

export default styles;
